import { createSlice, AsyncThunk, AnyAction } from '@reduxjs/toolkit';

interface LoadingStates {
  openAlert: boolean;
  status: 'success' | 'error';
  code: number | null;
  message: string | null;
  duration: number;
  isLoading: boolean;
  showLoading: false;
  errors: Error[];
}
const initialState: LoadingStates = {
  openAlert: false,
  status: 'success',
  code: null,
  message: null,
  duration: 0,
  isLoading: false,
  showLoading: false,
  errors: []
};

type GenericAsyncThunk = AsyncThunk<unknown, unknown, any>;
type PendingAction = ReturnType<GenericAsyncThunk['pending']>;
type RejectedAction = ReturnType<GenericAsyncThunk['rejected']>;
type FulfilledAction = ReturnType<GenericAsyncThunk['fulfilled']>;

function isPendingAction(action: AnyAction): action is PendingAction {
  return action.type.endsWith('/pending');
}
function isRejectedAction(action: AnyAction): action is RejectedAction {
  return action.type.endsWith('/rejected');
}
function isFulfilledAction(action: AnyAction): action is FulfilledAction {
  return action.type.endsWith('/fulfilled');
}

let countPending = 0;

export default createSlice({
  name: 'loadingStates',
  initialState,
  reducers: {
    success: (state, action) => {
      state.openAlert = true;
      state.status = 'success';
      state.message = action.payload.message;
      state.duration = 2000;
    },
    error: (state, action) => {
      state.openAlert = true;
      state.status = 'error';
      state.message = action.payload.message;
      state.duration = 5000;
    },
    clear: (state) => {
      state.openAlert = false;
      state.errors = [];
    },
    clearCode: (state) => {
      state.code = null;
    },
    setLoading: (state, action) => {
      state.showLoading = action.payload.showLoading;
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(isPendingAction, (state) => {
      countPending += 1;
      state.isLoading = true;
    });
    builder.addMatcher(isFulfilledAction, (state) => {
      countPending -= 1;
      if (countPending === 0) state.isLoading = false;
    });
    builder.addMatcher<{
      type: string;
      payload: { message: string };
      error: Error;
    }>(isRejectedAction, (state, action) => {
      const [message, code] = action.error.message.split('|');
      const errorMessage = `${message} (${code})`;
      countPending -= 1;
      state.openAlert = true;
      state.status = 'error';
      state.code = Number.parseInt(code, 10);
      state.message = errorMessage;
      state.duration = 5000;
      state.errors.push(action.error);
      console.error(errorMessage);
      if (countPending === 0) state.isLoading = false;
    });
  }
});
